import Button from "components/common/Button";
import PrimeBadge from "components/common/PrimeBadge";
import useBottomSheet from "hooks/common/useBottomSheet";
import { useEffect, useRef, useState } from "react";
import { BJProfile } from "types/models/bjProfile";
import { UserInfo } from "types/models/userInfo";

type PrimeSwipeCallResult = 'accept' | 'reject' | 'timeout';

const PrimeSwipeCall = () => {
    const { sheets, open, close } = useBottomSheet();
    const sheet = sheets.PrimeSwipeCall;
    const { bjUid } = sheet.data;
    const MAX_COUNTDOWN = 10;
    const [countdown, setCountdown] = useState(0);
    const [bjUserInfo, setbjUserInfo] = useState<UserInfo | null>(null);
    const [bjBJProfile, setBjBJProfile] = useState<BJProfile | null>(null);
    const refCountdown = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        const clear = () => {
            if (refCountdown.current) {
                clearInterval(refCountdown.current);
                refCountdown.current = null;
            }
        };

        refCountdown.current = setInterval(() => {

            if(countdown === -1) {
                clear();
                return;
            }

            if (countdown >= MAX_COUNTDOWN) {
                clear();
                close(sheet.id, { data: 'timeout' });
                return;
            }

            setCountdown((prev) => prev + 0.1);
        }, 100);
        return () => {
            clear();
        };
        

    }, [countdown, sheet.id, MAX_COUNTDOWN, close]);

    useEffect(() => {
        if (!bjUid) {
            return;
        }

        FriendsDataManager.getInfo(bjUid, (uid:string, profile:any) => {
            if (!uid) {
                return;
            }
            setbjUserInfo(profile);
        });

        PrimeDataManager.getBJProfile(bjUid, (err:string, profile:any) => {
            if (err) {
                return;
            }
            setBjBJProfile(profile);
        });
    },[bjUid]);

    const sendResult = (result: PrimeSwipeCallResult) => {
        RoomManager.chat('<psc>' + result);
        close(sheet.id, { data: result });
    };

    const handleRequest = (result: PrimeSwipeCallResult) => {
        if(result === 'accept' && MyDataManager.getCoin() < (bjBJProfile?.cost ?? 0)) {
            RoomManager.chat('<psc>purchase');
            open('NeedCoin', { data: { productIds: ['lcoin_550', 'lcoin_1200'], showShopBtn: false, premiumProductId: 'lcoin_1200', body: brsc.sheet_low_coins_swipecall } }).then((purchaseResult) => {
                if(purchaseResult?.data) {
                    sendResult(result);

                    ba('primeswipecall', undefined, {
                        actionType: 'purchase',
                        productId: purchaseResult?.data?.productId,
                        guest: {
                            fbUid: myinfo.fbUid,
                            country: myinfo.country,
                            gender: myinfo.gender,
                        },
                        bj: {
                            fbUid: bjUserInfo?.fbUid,
                            country: bjUserInfo?.country,
                            gender: bjUserInfo?.gender,
                        },
                    });
                }
            });
            setCountdown(-1);
            return;
        }

        sendResult(result);
    };
  return <div className="flex flex-col justify-center items-center">
    <div className="typography-headline-md text-center">LOVE MATCH</div>
    <div className="typography-body-sm text-center">{brsc.sheet_swipecall_req}</div>
    {countdown >= 0 && <ProgressBar progress={countdown / MAX_COUNTDOWN} />}
    <div className="flex flex-col rounded-xl overflow-hidden w-[50vw] my-2">
        <div className="relative w-full h-[50vw]">
            {bjUserInfo && <img className="w-full h-full object-cover" src={PhotoManager.getPrimePhotoURL(bjUserInfo, true)} alt="" />}
            {!bjUserInfo && <div className="w-full h-full bg-base-bg-subtle" />}
            {bjUserInfo && <div className="absolute start-0 bottom-2 flex gap-1 items-center justify-center text-center w-full">
                {<img className="flag" width="24" height="16" src={`/images/nation_flag/${bjUserInfo.country.toLowerCase()}.svg`} alt="" />}
                {<div className="typography-headline-sm">{bjUserInfo.nick}</div>}
            </div>}
            <div className="w-full absolute bottom-0 left-0 right-0 h-[36px]" style={{ background: 'linear-gradient(180deg, rgba(16, 16, 28, 0.00) 0%, rgba(16, 16, 28, 0.20) 100%)'}} />
        </div>
        <div className="w-full flex justify-center items-center bg-base-bg-strong pt-3 py-4">
            <PrimeBadge cost={bjBJProfile?.cost ?? 0} perSecond={10} />
        </div>
    </div>
    <div className="mt-4 flex w-full justify-center gap-3">
        <Button 
            onClick={() => handleRequest('reject')} 
            className="w-fit flex-none px-4" 
            style={{ text: '', icon: { name: '/icons/ic_close.svg', size: 28, color: 'filter-base-ic-white' }, color: 'btn-bg-normal', borderRadius: 'lg' }}
        />
        <Button 
            onClick={()=> handleRequest('accept')} 
            className="flex-1" 
            style={{ text: brsc.request_accept, icon: { name: '/icons/ic_heart.svg', size: 28, color: 'filter-semantic-lovematch-btn-ic-secondary' }, color: 'base-bg-lovematch-subtle', fontColor: 'btn-txt-lovematch-secondary', borderRadius: 'full' }}
        />
      </div>
  </div>;
};

const ProgressBar = ({ progress }: { progress: number }) => {
    return (
        <div className="progress-bar-bg w-[50vw] h-4 relative rounded-full overflow-hidden bg-base-bg-subtle my-2">
            <div className="progress-bar absolute start-0 top-0 h-full bg-btn-bg-lovematch-primary rounded-full" style={{ width: `${progress * 100}%`, transition: 'width 0.1s ease-in-out' }}></div>
        </div>
    );
};

export default PrimeSwipeCall;